export function downloadPetsContract(id) {
    return axios({
        url: `/api/test/insurance/pets/contract/take`,
        method: 'post',
        data: {
            contractId: id,
        },
    });
}